import {
	NATIVE_EMBED_EXTENSION_KEY,
	NATIVE_EMBED_EXTENSION_TYPE,
} from '@atlaskit/editor-common/extensions/manifest-helpers';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import type { EditorState } from '@atlaskit/editor-prosemirror/state';
import {
	findSelectedNodeOfType,
	type ContentNodeWithPos,
} from '@atlaskit/editor-prosemirror/utils';

/**
 * Returns the currently selected extension node, if any.
 */
const getSelectedExtension = (state: EditorState) => {
	const { schema, selection } = state;
	return findSelectedNodeOfType(schema.nodes.extension)(selection) || undefined;
};

/**
 * Checks whether a given ProseMirror node is a native-embed extension.
 */
export const isNativeEmbedNode = (node: PMNode): boolean => {
	return (
		node.type.name === 'extension' &&
		node.attrs?.extensionType === NATIVE_EMBED_EXTENSION_TYPE &&
		node.attrs?.extensionKey?.includes(NATIVE_EMBED_EXTENSION_KEY)
	);
};

/**
 * Returns the currently selected native-embed extension node, or undefined
 * if the selection is not inside a native-embed extension.
 */
export const getSelectedNativeEmbedExtension = (
	state: EditorState,
): ContentNodeWithPos | undefined => {
	const selected = getSelectedExtension(state);
	if (selected && isNativeEmbedNode(selected.node)) {
		return selected;
	}
	return undefined;
};
